export const USERS = 'USERS';
export const CREATE_USER = 'CREATE_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const SHOW_USER = 'SHOW_USER';
export const SEARCH_USERS = 'SEARCH_USERS';




// WEBPACK FOOTER //
// ./src/actions/users/actionTypes.js